import { Geetest } from '@uip-alpha/captcha-sdk'
const winHref = window.location.href
const isSitEnv =
    window.env === 'ALPHA' || winHref.indexOf('127.0.0.1') > -1 || winHref.indexOf('localhost') > -1 || winHref.indexOf('owf.sit.sf-express.com') > -1
const envType = isSitEnv ? 'sit' : 'prod'
// 目前支持的极验验证码的类型
export const captchaType = {
    LOGIN: 'login', // 登录
    QUERY_WAYBILL: 'queryWaybill' // 查单
}

// 极验验证码需要配置多套类型和环境的captchaId
export const captchaEnvId = {
    [captchaType.LOGIN]: {
        sit: 'd3904fa9a9f06085cfb4d4113466d434',
        prod: '38d9e379f9afed8b721d43bfbd6747ca'
    },
    [captchaType.QUERY_WAYBILL]: {
        sit: 'f1f17d80d3a8cbcc7bec2521573f5d4c',
        prod: '7aff034c32dd2092ef63d12b86a95aeb'
    }
}
// 极验滑块验证码前端开关
const BFF_CAPTCHA_API_KEY = {
    sit: 'b428fdda761d53341036f323',
    prod: 'f90631698642d0b0a398987e'
}

export const getGeetestCaptcha = (captchaTypeParam, callback) => {
    const geetest = new Geetest(
        {
            captchaId: captchaEnvId[captchaTypeParam][envType],
            onData: res => {
                callback(res)
            }
        }, {
            bffSwitchId: BFF_CAPTCHA_API_KEY[envType],
            channel: 'owf'
        }
    )
    return geetest
}



// WEBPACK FOOTER //
// ./src/util/load-geetest.js